import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CompanyDataService } from "../company-data.service";
import { infoCircle, eye, VAIconRegistryService } from "@va/core-library/icons";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { CompanyStatusResponse } from "../company-page.model";

@Component({
  selector: "app-company-status",
  templateUrl: "./company-status.component.html",
  styleUrls: ["./company-status.component.scss"],
})
export class CompanyStatusComponent implements OnInit {
  @Input() company: string;
  @Output() earningsPreviewEvent = new EventEmitter();
  companyStatusData: CompanyStatusResponse;
  showStatus = true;
  earningsDataAccess = false;

  earningsPreviewData;
  constructor(
    private service: CompanyDataService,
    private iconRegistryService: VAIconRegistryService,
  ) {
    this.iconRegistryService.registerIcons([infoCircle, eye]);
  }

  ngOnInit() {
    this.service
      .getCompanyStatusInfo(this.company)
      .pipe(
        catchError((err) => {
          console.error(err);
          return throwError(err);
        }),
      )
      .subscribe((resp) => {
        this.companyStatusData = resp;
        this.companyStatusData.showNextEstimated = this.companyStatusData
          .next_earning
          ? true
          : false;
        this.earningsDataAccess = this.companyStatusData.earnings_data_access;
      });
  }

  sendEarningsPreview() {
    this.earningsPreviewEvent.emit("");
  }
}
